/**
 * WebAppWrapper
 * 
 * Wraps the main app content for web, providing:
 * - Centered app container with max-width
 * - Context for child overlays to position correctly
 * - Proper isolation of app content from viewport
 * 
 * This component should wrap the content inside NavigationContainer
 * but outside of individual screens.
 */

import React from 'react';
import { View, StyleSheet } from 'react-native';
import WebAppContainer from './WebAppContainer';

interface WebAppWrapperProps {
  children: React.ReactNode;
}

const WebAppWrapper: React.FC<WebAppWrapperProps> = ({ children }) => {
  return (
    <WebAppContainer>
      <View style={styles.content}>
        {children}
      </View>
    </WebAppContainer>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
    width: '100%',
    position: 'relative',
  },
});

export default WebAppWrapper;

